import { Container, Loader } from './Spinner.style.js';

export const Spinner = ({ color }) => (
  <Container data-testid={'loading'}>
    <Loader color={color} alt="loading" />
  </Container>
);
